//EXTERNAL
import { useEffect } from "react"
import { useToasts } from "react-toast-notifications"
//COMPONENTS
//ASSETS
// import "./Notification.css"
//FUNCTIONS

const PageLoadNotification = ({ message, type }) => {
  const { addToast } = useToasts()
  useEffect(() => {
    addToast(message, {
      appearance: type
    })
  }, [])
  return null
}

export default PageLoadNotification
